module.exports = __webpack_public_path__ + "assets/void.cbcb76f2.svg";